import React from 'react';
import t from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  CardText,
  DashboardSection,
  InputWrapper,
} from 'fiducius-ui';
import { getUserId } from '../../auth';
import { withPermissions } from '../../routing';

class RepaymentNSLDSUpload extends React.Component {
  static propTypes = {
    id: t.number.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { redirectURI: '' };
  }

  componentDidMount() {}

  componentDidUpdate() {}

  redirectForNSLDSUpload = () => {
    this.setState({ ...this.state, redirectURI: '/nslds' });
  };

  render() {
    if (this.state.redirectURI && this.state.redirectURI.length > 0) {
      return <Redirect to={this.state.redirectURI} />;
    }

    return (
      <>
        <DashboardSection>
          <Card brand="primary">
            <CardBody>
              <CardTitle>NSLDS</CardTitle>
              <CardText>
                <p>
                  Completing this step will allow us to re-evaluate your Eligibility for Michigan
                  27k.
                </p>
              </CardText>
            </CardBody>
            <div className="row col-12">
              <div className="col-8"></div>
              <div className="col-4">
                <InputWrapper>
                  <Button brand="primary" onClick={this.redirectForNSLDSUpload}>
                    {'Upload NSLDS'}
                  </Button>
                </InputWrapper>
              </div>
            </div>
          </Card>
        </DashboardSection>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    id: getUserId(state),
  };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withPermissions(RepaymentNSLDSUpload));
